import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/output.css';
 
createApp(App).use(router).mount('#app')
  
window.copyClipboard = (text) => {
     
    cordova.plugins.clipboard.copy(text);
    
};

window.storeFile = (filename, data, mimeType) => {
    
    let blob = new Blob([data], {
        type: mimeType
    });
      
    if (window.cordova && cordova.platformId !== "browser") {
          
        document.addEventListener("deviceready", function () {
          
            let storageLocation = "";
    
            switch (device.platform) {
            
                case "Android":
              
                    storageLocation = cordova.file.externalDataDirectory;
                    break;
    
                case "iOS":
              
                    storageLocation = cordova.file.documentsDirectory;
                    break;
          
            }
    
            let folderPath = storageLocation;
    
          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                filename,
                {
                  create: true
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(blob);
    
                      fileWriter.onwriteend = function () {
                        var url = file.toURL();
                        cordova.plugins.fileOpener2.open(url, mimeType, {
                          error: function error(err) {
                            console.error(err);
                            alert("Unable to download");
                          },
                          success: function success() {
                            console.log("success with opening the file");
                          }
                        });
                      };
    
                      fileWriter.onerror = function (err) {
                        alert("Unable to download");
                        console.error(err);
                      };
                    },
                    function (err) {
                      // failed
                      alert("Unable to download");
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  alert("Unable to download");
                  console.error(err);
                }
              );
            },
            function (err) {
              alert("Unable to download");
              console.error(err);
            }
          );
        });
      } else {
        saveAs(blob, filename);
      }
    
}

document.addEventListener("deviceready", onDeviceReady, false);

function onDeviceReady() {
 
    //console.log('1#', navigator.camera);
    //console.log('2#', navigator.mediaDevices);    
    //navigator.mediaDevices = navigator.camera;
    
    window.platform = device.platform;
    
    document.getElementsByTagName('body')[0].classList.add(device.platform);
    
    //alert(device.platform);
    
}
 
window.sendMailCordova = (subject, body, to) => {
    
    try {
    
        cordova.plugins.email.open({
            app: 'mailto',
            to: to,
            subject: subject,
            body: body
        });

    } catch (Error) {

		window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        
        console.log('error', Error);
        
    }
        
};
 